'use client'

import { useState } from 'react'

interface RangeSliderProps {
	min: number
	max: number
	step: number
	unit?: string
	initialValue?: number
	onChange?: (value: number) => void
}

export default function RangeSlider({min, max, step, unit, initialValue, onChange}: RangeSliderProps) {
	const [value, setValue] = useState(initialValue || 0)
	return (
		<div className="w-full flex items-center gap-2">
			<input
				className='w-full'
				type="range"
				min={min}
				max={max}
				step={step}
				onChange={(e) => {
					setValue(+e.target.value)
					onChange && onChange(+e.target.value)
				}}
				value={value}
			/>
			<div className={`${unit ? "w-[7.2ch]" : "w-[5.4ch]"} font-500 text-sm leading-100 -tracking-10 text-center text-black dark:text-white bg-white dark:bg-black border border-black dark:border-white px-2 py-2 rounded-[8px]`}>
				{value}{unit}
			</div>
		</div>
	)
}
